import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _getIterator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/get-iterator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from '~/plugins/axios.js';
import moment from '~/plugins/Moment';

export default {
  name: "ViewApplicantsInfoList",
  data: function data() {
    return {
      tableFields: {
        applicantInfo: {
          key: 'applicantInfo',
          label: 'Applicant Info'
        },
        workingProfile: {
          key: 'workingProfile',
          label: 'Working Profile'
        },
        moreInfo: {
          key: 'moreInfo',
          label: 'More Information'
        }
      },
      viewMoreInfoModal: {
        title: '',
        content: {
          manager: {},
          bookedModules: {},
          moduleSessionList: []
        }
      },
      nricFin: null

    };
  },

  filters: {
    momentFilter: function momentFilter(timing) {
      return moment(timing, ['X']).format('DD-MM-YYYY HH:mm');
    }
  },
  methods: {
    checkMoreInfo: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(user, index, btn) {
        var managerId, manager, moduleSessionList, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, msId, moduleSession, mss;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('\n\n ===== View Applicant Info List <|-- checkMoreInfo ====\n user: ', user, '\n index: ', index, '\n btn: ', btn, '\n ---------------------------');
                this.nricFin = user.nricFin;
                this.viewMoreInfoModal.title = user.fullname + ' | ' + user.nricFin + ' | ' + user.companyName;
                this.$root.$emit('bv::show::modal', 'viewUserMoreInfoModal', btn);

                managerId = 'userMsManager' + user.id;
                _context.next = 7;
                return axios.post('/userMsManager/obtainSingleManager', { managerId: managerId });

              case 7:
                manager = _context.sent.data.manager;

                console.log('\n\n ======= View Applicant Info List <|-- userMsManager ======= \n', manager, '\n ------------------------');

                this.viewMoreInfoModal.content.manager = manager;

                moduleSessionList = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 14;
                _iterator = _getIterator(manager.bookedModules);

              case 16:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 28;
                  break;
                }

                msId = _step.value;
                _context.next = 20;
                return axios.get('/moduleSession/' + msId);

              case 20:
                moduleSession = _context.sent.data;
                _context.next = 23;
                return axios.post('/userMsStatus/msId', { msId: msId });

              case 23:
                mss = _context.sent.data;

                if (mss['msStatus'] === 102) {
                  moduleSessionList.push(moduleSession);
                }

              case 25:
                _iteratorNormalCompletion = true;
                _context.next = 16;
                break;

              case 28:
                _context.next = 34;
                break;

              case 30:
                _context.prev = 30;
                _context.t0 = _context['catch'](14);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 34:
                _context.prev = 34;
                _context.prev = 35;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 37:
                _context.prev = 37;

                if (!_didIteratorError) {
                  _context.next = 40;
                  break;
                }

                throw _iteratorError;

              case 40:
                return _context.finish(37);

              case 41:
                return _context.finish(34);

              case 42:

                this.viewMoreInfoModal.content.moduleSessionList = moduleSessionList;

              case 43:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[14, 30, 34, 42], [35,, 37, 41]]);
      }));

      function checkMoreInfo(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return checkMoreInfo;
    }(),
    resetMoreInfoModal: function resetMoreInfoModal(modal) {
      modal.title = '';
      modal.content = [];
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/viewingInfo/ViewApplicantsInfoList.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/viewingInfo/ViewApplicantsInfoList.vue
// module chunks = 2